import { AnyAction } from 'redux';
import { ExtremwetterschutzSelbstbeteiligung } from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export const extremWetterschutzSelbstbeteiligungReducer = function (
  sectionState: ExtremwetterschutzSelbstbeteiligung = null,
  action: AnyAction,
  appState: IAppState,
): ExtremwetterschutzSelbstbeteiligung {
  switch (action.type) {
    case VwgActions.PLZ_CHANGED:
    case VwgActions.ORT_CHANGED:
    case VwgActions.STRASSE_CHANGED:
    case VwgActions.HAUSNUMMER_CHANGED:
    case VwgActions.MAP_COORDINATES_VWG_CHANGED_EINGABE:
    case VwgActions.MAP_COORDINATES_VWG_CHANGED_ANGEBOT: {
      return null;
    }
    case VwgActions.EXTREMEWETTERSCHUTZ_SELBSTBETEILIGUNG_CHANGED: {
      let newSectionState = cloneDeep(sectionState);
      if (appState.angebotsId === action.payload.angebotsId) {
        newSectionState = action.payload.extremWetterschutzSelbstbeteiligung;
        return newSectionState;
      }
      break;
    }
    default:
      return sectionState;
  }
};
